module.exports = __webpack_public_path__ + "img/about-m-slide-9.5e746839.jpg";